let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dgVPn")).then(() => parcelRequire('aOuuG'));